<template>
    <div class="">
        <input type="hidden" name="config" :value="JSON.stringify(config)">

        <div v-if="!(options.lists['pharmacies-wholesalers'] || []).length">
            <div class="card shadow mb-3">
                <div class="card-body">
                    Bitte eine Liste vom Typ <b>Apotheken mit Großhandel</b> anlegen!
                </div>
            </div>
        </div>

        <div v-else>
            <timing-period-module :dto="config.timing" :options="options" :compare="false"></timing-period-module>

            <div class="card shadow mb-3">
                <div class="card-header py-3">
                    <h6 class="m-0 font-weight-bold text-primary">Optionen</h6>
                </div>
                <div class="card-body">

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['gh.liefer.wholesaler']"></i>
                            Großhändler zur Berechnung
                        </label>
                        <custom-select v-model="config.wholesalerIds"
                                       :settings="wholesalerSettings"
                                       :options="wholesalers"/>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['gh.liefer.einkauf']"></i>
                            Apotheken nach Großhandel filtern
                        </label>
                        <div class="mb-2">
                            <button type="button" class="btn btn-sm btn-outline-primary" @click="config.wholesalerFilter.push([null, null])">Hinzufügen</button>
                        </div>
                        <div class="row mb-1" v-for="(row, index) in config.wholesalerFilter">
                            <div class="col">
                                <select class="form-control" v-model="row[0]">
                                    <option :value="null">Großhandel auswählen</option>
                                    <option :value="wholesaler.id" v-for="wholesaler in wholesalersWithShort">
                                        {{ wholesaler.short }}
                                    </option>
                                </select>
                            </div>
                            <div class="col">
                                <select class="form-control" v-model="row[1]">
                                    <option :value="null">Status Egal</option>
                                    <option :value="1">Status 1</option>
                                    <option :value="2">Status 2</option>
                                    <option :value="3">Status 3</option>
                                    <option :value="4">Status 4</option>
                                    <option :value="5">Status 5</option>
                                    <option :value="6">Status 6</option>
                                    <option :value="7">Status 7</option>
                                    <option :value="8">Status 8</option>
                                    <option :value="9">Status 9</option>
                                    <option :value="10">Status 10</option>
                                </select>
                            </div>
                            <div class="col-auto">
                                <button type="button" class="btn btn-outline-danger" @click="config.wholesalerFilter.splice(index, 1)">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>
                            <i class="fas fa-info-circle text-muted"
                               style=""
                               data-toggle="tooltip"
                               data-placement="top"
                               :title="$info['gh.liefer.einkauf']"></i>
                            Preisfilter
                        </label>
                        <select class="form-control" v-model="config.einkaufFilter">
                            <option value="disabled">Keiner</option>
                            <option value="between">Listen EK zwischen</option>
                        </select>
                    </div>

                    <div class="row" v-if="config.einkaufFilter !== 'disabled'">
                        <div class="col">
                            <div class="form-group">
                                <label>Min</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Euro</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="0" v-model="config.einkaufMin">
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group">
                                <label>Max</label>
                                <div class="input-group">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Euro</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder="0" v-model="config.einkaufMax">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-group">
                        <label>
                            PZN Seite berechnen
                        </label>
                        <select class="form-control" v-model="config.calculatePznPage">
                            <option :value="true">Ja</option>
                            <option :value="false">Nein</option>
                        </select>
                    </div>

                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="alert alert-info" role="alert">
                        <i class="fas fa-fw fa-info"></i>
                        {{ $info['gh.apoListe'] }}
                    </div>

                    <filtering-module :dto="config.filtering"
                                      :options="options"
                                      :pharmacies="true"
                                      :warengruppen="true"
                                      :dar="true"
                                      :menge="true"
                                      :wirkstoffe="true"
                                      :reimport="true"></filtering-module>
                </div>
            </div>
        </div>

        <pre v-if="$debugEnabled">{{ JSON.stringify(config, 0, 2) }}</pre>
    </div>
</template>

<script>

import TimingPeriodModule from "../../Modules/TimingPeriodModule";
import FilteringModule from "../../Modules/FilteringModule";
import PharmacyFilterModule from "../../Modules/PharmacyFilterModule";

export default {
    components: {FilteringModule, TimingPeriodModule, PharmacyFilterModule},
    props: {
        dto: {
            type: Object,
            required: true
        },
        options: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            config: this.dto,
            wholesalerSettings: {
                multiple: true,
                tags: false,
            }
        };
    },
    computed: {
        wholesalers() {
            return [
                {id: 'direkt', text: 'Direkt'},
                ...this.options.wholesalers.map((wholesaler) => {
                    return {
                        id: wholesaler.id,
                        text: wholesaler.short
                    };
                })
            ];
        },
        wholesalersWithShort() {
            return this.options.wholesalers.filter((wholesaler) => !!wholesaler.short);
        }
    }
}
</script>
